import { FC } from 'react';
import Button from 'src/presentations/components/atom/button';
import { ITopButtonProps } from './types';

export const TopButton: FC<ITopButtonProps> = (props) => {
  const { title, icon, path } = props;

  return (
    <Button path={path} variant='neutral_outline' rounded='large' className='min-w-0 px-10 xl:px-14'>
      <div className='flex items-center gap-10'>
        <img src={icon} alt='' className='w-18 xl:w-20' />
        <span className='text-12 xl:text-16'>{title}</span>
      </div>
    </Button>
  );
};
